export default __webpack_public_path__ + "static/media/km4.8c9407eb.jpg";